import { render, staticRenderFns } from "./main.ticket-detail.vue?vue&type=template&id=3147cff2"
import script from "./main.ticket-detail.vue?vue&type=script&lang=ts"
export * from "./main.ticket-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports